import { LeverageTokensTableContainer } from "./table/IlmTableContainer";

export const LeverageTokensTab = () => {
  return (
    <div>
      <LeverageTokensTableContainer />
    </div>
  );
};
